import { generateSrcSet, imageSettings } from "../../../utils/generateSrcSet";

export const Image = ({
  url,
  title,
  colour,
  index,
  testId = "product-image",
  className,
  loading = "",
}: {
  url: string;
  title: string;
  colour: string;
  index: number;
  loading?: "eager" | "lazy" | "";
  testId?: string;
  className?: string;
}) => {
  const { aspectRatio, defaultWidth } = imageSettings;
  const { src, srcSet } = generateSrcSet(url);
  return (
    <img
      width={defaultWidth}
      height={Math.round(defaultWidth / aspectRatio)}
      alt={`${title}, ${colour || ""}`}
      loading={loading ? loading : index < 4 ? "eager" : "lazy"}
      data-testid={testId}
      src={src}
      srcSet={srcSet}
      {...(className && { className })}
    />
  );
};
